import { Builder } from 'builder-pattern';
import { StayLocation } from '../../src/types/location.types';

const StayLocationFactory = () =>
  Builder<StayLocation>()
    .full(
      Builder<StayLocation['full']>()
        .latlon(['-27.46794,153.02809'])
        .iata('BNE')
        .destination_service_id(103542)
        .name('Brisbane')
        .type('city')
        .country_iso2('AU')
        .slug('au-qld-brisbane')
        .geonames_id(2174003)
        .province_name('Queensland')
        .build(),
    )
    .name('Brisbane')
    .iata('BNE')
    .coordinates('-27.46794,153.02809')
    .country('AU')
    .type('city')
    .slug('au-qld-brisbane')
    .destination_service_id(103542)
    .build();

export default StayLocationFactory;
